import { render, staticRenderFns } from "./RolesGroupPermissionCard.vue?vue&type=template&id=907533ca"
import script from "./RolesGroupPermissionCard.vue?vue&type=script&lang=js"
export * from "./RolesGroupPermissionCard.vue?vue&type=script&lang=js"
import style0 from "./RolesGroupPermissionCard.vue?vue&type=style&index=0&id=907533ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports